import React from "react";
import {claimTypes} from "../../../../constants/claim.constants";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import {Button} from "react-bootstrap";

const WidgetLantick = ({ lantickData, callbackAction, user, claim , t}) => {
    const claimAccess = user[`c_${claim}`] || null;
    if(claimAccess === claimTypes.NONE) {
        return (
            // return when claims is none
            <React.Fragment/>
        )
    }

    const handleActions = (action) => {
        callbackAction(action);
    };

    console.log(lantickData);

    return (
        lantickData?.length > 0 ? (
            <div className="card my-2">
                <div className="card-header">
                    <div className="card-title d-flex w-100">
                        <b className="align-self-center"> { t('Lantick') } </b>
                        <div className="ml-auto d-flex">
                            <Button className="m-1"
                                    variant={ lantickData?.filter((item) => item.manualTurnOn !== null).length > 0 ? "outline-success" : "success"}
                                    onClick={() => handleActions(`RestoreScheduleAllLanticks`)}>
                                <i className="fas fa-sync"> </i> &nbsp; {t('restore-schedule')}
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="list-group mx-2">
                        { lantickData?.map((item, idx) => {
                            return (
                                <div key={idx} className="list-group-item list-group-item-action">
                                    <div className="row">
                                        <div className="col-md-3 d-flex">
                                            <div className="flex-column align-content-center">
                                                <p><small>{item.deviceType.label}</small></p>
                                                <span className="text-wrap font-weight-bold align-self-center">{`${item.label}`}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-9">
                                            <div className="flex-wrap">
                                                <Button variant="outline-primary"
                                                        className={`m-1 ${item.manualTurnOn === true ? "active" : ""}`}
                                                        onClick={() => handleActions(`setlanticstate/${item.id}/true `)}
                                                >
                                                    <i className="fas fa-power-off"/> &nbsp;
                                                    {t('turn-on')}
                                                </Button>

                                                <Button variant="outline-danger"
                                                        className={`m-1 ${item.manualTurnOn === false ? "active" : ""}`}
                                                        onClick={() => handleActions(`setlanticstate/${item.id}/false `)}
                                                >
                                                    <i className="fas fa-power-off"/> &nbsp;
                                                    {t('turn-off')}
                                                </Button>

                                                <Button variant={"outline-secondary"}
                                                        className="m-1"
                                                        onClick={() => handleActions(`RestoreScheduleLantick/${item.id}`)}
                                                >
                                                    <i className="fas fa-sync"/> &nbsp;
                                                    { t('restore') }
                                                </Button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }) }
                    </div>
                </div>
            </div>
        ) : (
            <React.Fragment/>
        )

    )

}
const mapStateToProps = state => {
    const {user} = state.authenticationReducer;
    return {
        user
    }
};

export default withNamespaces()(connect(mapStateToProps)(WidgetLantick));
